import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, Card, Space, Button } from 'antd';
import { DeviceType, Rescues, RescuesDevice } from '@services/types';
import { toast } from 'react-toastify';
import api from '@services/api';
import { useHistory, useParams } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';

const { Option } = Select;

interface Option {
  id: string;
  version: string;
}

const CreateRescueModal = () => {
  const [form] = Form.useForm();
  const { id }: { id: string } = useParams();
  const history = useHistory();
  const [data, setData] = useState<RescuesDevice>();
  const [rescueToUpdate, setRescueToUpdate] = useState<Rescues>();
  const [selectedDevice, setSelectedDevice] = useState<DeviceType['id']>();
  const [deviceVersions, setDeviceVersions] = useState<any>([]);
  const [type, setType] = useState('');
  const [options, setOptions] = useState<Option[]>([]);
  const [firmware, setFirmware] = useState<any>();

  useEffect(() => {
    api.rescue.getDeviceRescue().then((data) => {
      setData(data);
    });
  }, []);

  useEffect(() => {
    if (id) {
      api.rescue.getRescueById(id).then((data) => {
        setRescueToUpdate(data);
      });
    }
  }, []);
  const onClose = () => {
    history.push(Navigation.Rescue);
  };
  useEffect(() => {
    if (selectedDevice?.length) {
      api.rescue.getFirmwareRescue({ deviceTypeId: selectedDevice }).then((el) => setDeviceVersions(el));
    } else if (rescueToUpdate?.id && rescueToUpdate?.deviceTypeId) {
      api.rescue.getFirmwareRescue({ deviceTypeId: rescueToUpdate?.deviceTypeId }).then((el) => setDeviceVersions(el));
    }
  }, [selectedDevice, rescueToUpdate?.deviceTypeId]);

  const handleSubmit = async () => {
    try {
      if (rescueToUpdate) {
        await api.rescue.updateRescue({
          deviceTypeId: rescueToUpdate.deviceTypeId!,
          newFirmwareId: firmware,
          currentFirmwareId: rescueToUpdate.currentRescueFirmware?.id ?? '',
        });
        toast.success('Rescue was updated successfully');
        form.resetFields();
      } else {
        await api.rescue.createRescue({ deviceTypeId: selectedDevice!, newFirmwareId: firmware });
        toast.success('Rescue was created successfully');
        form.resetFields();
      }
      form.resetFields();
      onClose();
    } catch (error) {
      toast.error('Rescue was not updated/created due to error');
      console.log(error);
    }
  };
  const handleTypeChange = (value: string) => {
    setType(value);
    setOptions(deviceVersions[value] || []);
  };
  console.log(deviceVersions);

  return rescueToUpdate ? (
    <Card
      title="Update an rescue"
      extra={
        <Space>
          <Button type="default" onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit}>
            Update
          </Button>
        </Space>
      }
    >
      <Form style={{ marginTop: '20px' }} layout="vertical" form={form}>
        {selectedDevice?.length || rescueToUpdate?.deviceTypeId ? (
          <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr' }}>
            <Form.Item
              label="Select Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: 'Please select your type!',
                },
              ]}
            >
              <Select value={type} onChange={handleTypeChange} style={{ width: '150px' }}>
                {Object.keys(deviceVersions).map((key) => (
                  <Option key={key} value={key}>
                    {key}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Select Version"
              name="value"
              rules={[
                {
                  required: true,
                  message: 'Please select your version!',
                },
              ]}
            >
              <Select
                disabled={!type}
                onChange={(e) => {
                  setFirmware(e);
                }}
              >
                {options.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.version}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        ) : null}
      </Form>
    </Card>
  ) : !id ? (
    <Card
      title="Create a new rescue"
      extra={
        <Space>
          <Button type="default" onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit}>
            Create
          </Button>
        </Space>
      }
    >
      <Form style={{ marginTop: '20px' }} layout="vertical" form={form}>
        <Form.Item
          label="Select Device Type"
          name="device_type"
          rules={[
            {
              required: true,
              message: 'Please input your Device Type!',
            },
          ]}
        >
          <Select
            allowClear
            showSearch
            onChange={(e: DeviceType['id']) => {
              setSelectedDevice(e);
            }}
            value={selectedDevice}
          >
            {data?.elements.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.deviceName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {selectedDevice?.length ? (
          <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr' }}>
            <Form.Item
              label="Select Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: 'Please select your type!',
                },
              ]}
            >
              <Select value={type} onChange={handleTypeChange} style={{ width: '150px' }}>
                {Object.keys(deviceVersions).map((key) => (
                  <Option key={key} value={key}>
                    {key}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Select Version"
              name="value"
              rules={[
                {
                  required: true,
                  message: 'Please select your version!',
                },
              ]}
            >
              <Select
                disabled={!type}
                onChange={(e) => {
                  setFirmware(e);
                }}
              >
                {options.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.version}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        ) : null}
      </Form>
    </Card>
  ) : null;
};

export default React.memo(CreateRescueModal);
